import { ISelectOptions } from "@/utils/models/core";
import clsx from "clsx";
import {
	SvgBreak,
	SvgCare,
	SvgClockIn,
	SvgSick,
	SvgUnavailable,
	SvgVacation,
} from "@/components/SvgIcon";

interface IButtonStatus {
	setStatus: (x: string) => void;
	item: ISelectOptions;
	index: number;
	status: string;
	setActivity: (x: string) => void;
	activity: string;
}
export const ButtonStatus = ({
	setStatus,
	item,
	index,
	status,
	setActivity,
	activity,
}: IButtonStatus) => {
	const _renderIcon = (status: string) => {
		switch (status) {
			case "vacation-leave":
				return <SvgVacation className="w-5 h-5" />;
			case "clocked-in":
				return <SvgClockIn className="w-5 h-5" />;
			case "sick-leave":
				return <SvgSick className="w-5 h-5" />;
			case "carers-leave":
				return <SvgCare className="w-5 h-5" />;
			case "unavailable":
				return <SvgUnavailable className="w-5 h-5" />;
			case "on-break":
				return <SvgBreak className="w-5 h-5" />;
			default:
				null;
		}
	};

	return (
		<button
			onClick={() => {
				setStatus(item.value);
				setActivity(item.others);
			}}
			className={clsx(
				"p-2 w-full rounded-md bg-opus-blue-100",
				status === item.value ? `bg-opus-blue-100` : "bg-opus-gray-600 "
			)}
			key={index}>
			<div className="flex space-x-2 items-center">
				<div
					className={clsx(
						status === item.value ? "text-white" : "text-opus-gray-100"
					)}>
					{_renderIcon(item.value)}
				</div>
				<div
					className={clsx(
						status === item.value ? "text-white" : "text-opus-gray-100"
					)}>
					{item.label}
				</div>
			</div>
		</button>
	);
};
